<template>
  <svg :width="size" :height="size" viewBox="0 0 14 14"
       fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 8.66667V12H4.66667V8.66667H1.33333ZM8.66667 8.66667V12H12V8.66667H8.66667ZM1.33333 1.33333V4.66667H4.66667V1.33333H1.33333ZM8.66667 1.33333V4.66667H12V1.33333H8.66667ZM6 12C6 12.7364 5.40305 13.3333 4.66667 13.3333H1.33333C0.596954 13.3333 0 12.7364 0 12V8.66667C0 7.93029 0.596954 7.33333 1.33333 7.33333H4.66667C5.40305 7.33333 6 7.93029 6 8.66667V12ZM13.3333 12C13.3333 12.7364 12.7364 13.3333 12 13.3333H8.66667C7.93029 13.3333 7.33333 12.7364 7.33333 12V8.66667C7.33333 7.93029 7.93029 7.33333 8.66667 7.33333H12C12.7364 7.33333 13.3333 7.93029 13.3333 8.66667V12ZM6 4.66667C6 5.40305 5.40305 6 4.66667 6H1.33333C0.596954 6 0 5.40305 0 4.66667V1.33333C0 0.596954 0.596954 0 1.33333 0H4.66667C5.40305 0 6 0.596954 6 1.33333V4.66667ZM13.3333 4.66667C13.3333 5.40305 12.7364 6 12 6H8.66667C7.93029 6 7.33333 5.40305 7.33333 4.66667V1.33333C7.33333 0.596954 7.93029 0 8.66667 0H12C12.7364 0 13.3333 0.596954 13.3333 1.33333V4.66667Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'CollectionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    fill: {
      type: String,
      default: '#8A8D93',
    },
  },
};
</script>